import React from 'react'
import Playstore from '../../assets/images/Playstore.svg'
import Appstore from '../../assets/images/Appstore.svg'
import Phone from '../../assets/images/phone.png'

const Hero = () => {
    const { REACT_APP_APP_STORE_URL, REACT_APP_PLAY_STORE_URL } = process.env
    return (
        <div className="md:flex md:items-center lg:items-start grid justify-between">
            <div className="md:pr-4 md:w-8/12 md:mr-2 lg:mr-0">
                <div>
                    <h3 className="text-[24px] font-light text-[#262626] leading-[133.2%] 2xl:text-3xl">
                        Whoops!
                    </h3>
                    <p className="text-[18px] text-[#5A5A60] font-light leading-[27px] 2xl:text-xl">
                        This link leads to a quest inside the Questeon app
                    </p>
                </div>
                <div className="pt-4">
                    <h2 className="text-[32px] md:text-[36px] 2xl:text-7xl font-bold leading-[120%]">
                        To view this quest, make sure to{' '}
                        <span className="text-[#2c7d92]">
                            access the link from your mobile device,
                        </span>{' '}
                        not your computer
                    </h2>
                </div>
                <div className="pt-[30px]">
                    <p className="text-[14px] text-[#5A5A60] font-light leading-[21px] 2xl:text-lg">
                        Don’t have the app yet? Download free here :
                    </p>
                    <div className="flex pt-[24px]">
                        <a href={REACT_APP_APP_STORE_URL} className="pr-3">
                            <img
                                src={Appstore}
                                alt="appstore"
                                className="h-[54px] 2xl:h-[60px]"
                            />
                        </a>
                        <a href={REACT_APP_PLAY_STORE_URL}>
                            <img
                                src={Playstore}
                                alt="playstore"
                                className="h-[54px] 2xl:h-[60px]"
                            />
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div className="invisible md:visible">
                    <img
                        src={Phone}
                        className="w-[491px] 2xl:w-[650px]"
                        alt="phone1"
                    />
                </div>
            </div>
        </div>
    )
}

export default Hero
